import { string, object } from '@/utils/validations';

export default object({
  partnerId: string().required('É necessário selecionar uma Gerenciadora de Risco para continuar'),
});
